export type LegalInfo = {
  legalName: string;
  tradingName?: string;
  companyNumber?: string;
  registeredIn?: string; // e.g. "England and Wales"
  registeredOfficeAddress?: string;
  vatNumber?: string;
  publicEmail?: string;
  publicPhone?: string;
  dataProtectionEmail?: string;
  icoRegistrationNumber?: string;
  websiteDomain?: string; // e.g. kisscoffeeminehead.co.uk
};

// Fill in these values and rebuild to surface company details across the site
export const legalInfo: LegalInfo = {
  legalName: "Kiss Coffee Minehead", // Update if different from trading name
  tradingName: "Kiss Coffee Minehead", // Optional
  companyNumber: "", // e.g. 12345678
  registeredIn: "England and Wales",
  registeredOfficeAddress: "16 Friday Street, Minehead, TA24 5UA", // Update if different
  vatNumber: "", // e.g. GB123456789
  publicEmail: "kisscoffeeminehead@gmail.com",
  publicPhone: "07447786761",
  dataProtectionEmail: "kisscoffeeminehead@gmail.com",
  icoRegistrationNumber: "", // e.g. Z1234567 (if registered)
  websiteDomain: "kisscoffeeminehead.co.uk"
};

export type CookieConsentCategories = {
  necessary: boolean; // always true and enforced
  preferences: boolean;
  analytics: boolean;
  marketing: boolean;
};

export const COOKIE_CONSENT_STORAGE_KEY = "cookieConsent.v1";

export function getStoredCookieConsent(): CookieConsentCategories | null {
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as CookieConsentCategories;
    return {
      necessary: true,
      preferences: !!parsed.preferences,
      analytics: !!parsed.analytics,
      marketing: !!parsed.marketing
    };
  } catch {
    return null;
  }
}

export function storeCookieConsent(consent: CookieConsentCategories) {
  const value: CookieConsentCategories = {
    necessary: true,
    preferences: !!consent.preferences,
    analytics: !!consent.analytics,
    marketing: !!consent.marketing
  };
  localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, JSON.stringify(value));
}



